import { TooltipWrapper } from 'components/TooltipWrapper';
import type {
    CatalogUerBaseCostEstimateBasisItem,
    CatalogUerBaseCostEstimateBasisRow,
    CollectionUerBaseCostEstimateBasisRow,
} from 'gql/graphql';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';
import { useMemo } from 'react';

import type { TUerBaseCostEstimateBasisRow } from '../hooks/useUERBaseCostEstimateBasisRowsGrouped';

export const CodeCellRendererComponent: React.FC<
    ICellRendererParams<
        | TUerBaseCostEstimateBasisRow<CatalogUerBaseCostEstimateBasisRow>
        | TUerBaseCostEstimateBasisRow<CollectionUerBaseCostEstimateBasisRow>
        | CatalogUerBaseCostEstimateBasisItem
    >
> = (props) => {
    const { data } = props;

    const { message, style } = useMemo(() => {
        if (data?.isDeleted) {
            return { message: 'Позиция удалена', style: { width: 120 } };
        }

        if (data?.isNotCount) {
            return {
                message: 'Позиция не учитывается в стоимости расценки',
                style: { width: 170 },
            };
        }

        return { message: '', style: undefined };
    }, [data?.isDeleted, data?.isNotCount]);

    return (
        <TooltipWrapper message={message} isHidden={!message} toolTipStyle={style}>
            {data?.code}
        </TooltipWrapper>
    );
};

CodeCellRendererComponent.displayName = 'CodeCellRendererComponent';
